import { RestApi } from "../services/rest-api";

export interface Master {
  id: number | string;
  name: string;
}

export interface ItemMaster extends Master {
  rate?: number;
}
export interface ColorMaster extends Master { }
export interface BrandMaster extends Master { }
export interface AccountMaster extends Master {
  address: string;
  balance: number;
}
export interface AgentMaster extends Master {
  payment_days: number;
}

export const fetchMasters = async (type: string, authInfo: any) => {
  return await RestApi<{
    items?: Array<ItemMaster>,
    colors?: Array<ColorMaster>,
    brands?: Array<BrandMaster>,
    accounts?: Array<AccountMaster>,
    agents?: Array<AgentMaster>,
  }>('post', `masters/${type}`, {}, authInfo.user.authorization).then(function (response) {
    return response;
  });
};